import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {useHistory} from "react-router-dom";
import axios from "axios";
import "./Register.css";
import {Col, Container, Row} from "react-bootstrap";
import CustomAlert from "./CustomAlert";

function Register() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [validated, setValidated] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const history = useHistory();

    function handleSubmit(event) {
        setValidated(true);
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            return;
        }

        axios.post("/api/register", {
            'username': username,
            'password': password,
            'firstName': firstName,
            'lastName': lastName,
            'email': email
        }).then(resp => {
            setHasError(false);
            history.push('/success_register');
        }).catch(function (error) {
            setHasError(true);
            let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                error.response.data[0].description : 'Something went wrong. Please try again'
            setErrorMessage(errorMessage);
        });
    }

    const renderError = () => {
        if (hasError) {
            return <CustomAlert variant={'danger'} message={errorMessage}/>;
        }
    };

    const login = () => {
        history.push('/login');
    }

    return (
        <Container>
            <Form noValidate
                  validated={validated}
                  className="mt-4 mb-5"
                  onSubmit={handleSubmit}>

                <h2 className="mt-4 mb-5">Register User</h2>

                <Row>
                    <Col>
                        <Form.Group controlId="validationFirstName">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control type="text" placeholder="First name"
                                          pattern="[\u0370-\u03FF\u1F00-\u1FFFA-Za-z]+"
                                          onChange={(e) => setFirstName(e.target.value)}
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please fill a valid first name
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <Form.Group controlId="validationLastName">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control type="text" placeholder="Last name"
                                          pattern="[\u0370-\u03FF\u1F00-\u1FFFA-Za-z]+"
                                          onChange={(e) => setLastName(e.target.value)}
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please fill a valid last name
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <Form.Group controlId="validationEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="email"
                                          onChange={(e) => setEmail(e.target.value)}
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please fill an email
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <Form.Group controlId="validationUsername">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Username"
                                          onChange={(e) => setUsername(e.target.value)}
                                          minLength="5"
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please choose a username with minimum 5 characters
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <Form.Group controlId="validationPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password"
                                          onChange={(e) => setPassword(e.target.value)}
                                          minLength="8"
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please choose a password with minimum 8 characters
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <Button block md="12" type="submit">Submit</Button>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        {renderError()}
                        <div className="login-link">
                            <div>Already have an account?</div>
                            <a href="" onClick={login}>Back to login page</a>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Container>
    )
}

export default Register;